import React from "react"
import {useAccessToken, useUserClaimsData} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getDynamicInterestRate} from "../../resources/interestRate"
import {AsyncResultZipComponent} from "../../containers/AsyncResult/AsyncResult"
import {formatPercent} from "../../utilities/numbers"
import {InterestFormulaItem, InterestItem, PrimeLoanRateItem} from "./InterestItem"

import {findClientOrgBankAgreement} from "../../resources/clientOrgBankAgreement"

const RATE_FORMAT = "111.[11]%"

const InterestPending = () => (
	<>
		<InterestItem icon={"Percentage Increase"} />
		<InterestItem icon={"Percentage Decrease"} />
	</>
)

export function InterestOverviewForOrgUser() {
	const accessToken = useAccessToken()
	const orgId = useUserClaimsData().orgId
	const interestRateResult = useAsyncResult(() => getDynamicInterestRate(accessToken))
	const agreements = useAsyncResult(() => findClientOrgBankAgreement(accessToken, [orgId]))

	return (
		<div className={"interest-rate-overview"}>
			<AsyncResultZipComponent
				asyncResult1={interestRateResult}
				asyncResult2={agreements}
				pendingComponent={<InterestPending />}
			>
				{({value1: interestRate, value2: agreements}) => {
					const {
						data: {
							attributes: {upperBoundRate, lowerBoundRate, effectiveFrom},
						},
					} = interestRate
					const upperTargetRange = upperBoundRate / 100
					const lowerTargetRange = lowerBoundRate / 100
					const additionalInfoString = `Effective from ${effectiveFrom}`
					return (
						<>
							<div className="interest-items">
								<InterestItem
									icon={"Percentage Increase"}
									title={"Federal Funds Upper Target Range"}
									value={formatPercent(upperTargetRange, RATE_FORMAT)}
									additionalInfo={additionalInfoString}
								/>
								<InterestItem
									icon={"Percentage Decrease"}
									title={"Federal Funds Lower Target Range"}
									value={formatPercent(lowerTargetRange, RATE_FORMAT)}
									additionalInfo={additionalInfoString}
								/>
								<PrimeLoanRateItem />
							</div>
							<div className="interest-formula-items">
								{agreements.map((oba) => (
									<InterestFormulaItem
										key={oba.id}
										title={`Calculation Formula for ${oba.attributes.bankName}`}
										interestFormula={oba.attributes.interestFormula}
										fedLowerBound={lowerBoundRate}
										fedUpperBound={upperBoundRate}
									/>
								))}
							</div>
						</>
					)
				}}
			</AsyncResultZipComponent>
		</div>
	)
}

export function InterestForOrgUser() {
	return (
		<div className="card">
			<div className="interest-rate-container">
				<h3>Interest</h3>
				<div className="columns is-align-items-center">
					<div className="column is-12 is-align-self-flex-end">
						<InterestOverviewForOrgUser />
					</div>
				</div>
			</div>
		</div>
	)
}
